"use client";

import React from "react";
import { FloatingPaths } from "./FloatingPaths";

export function HomePageBackground({ children }: { children: React.ReactNode }) {
  return (
    <div className="relative w-full max-w-full min-w-0 overflow-x-clip bg-[#fff8f0] dark:bg-neutral-950">
      {/* Background Gradient Layer - Completely Static and Smooth (No blinking, pulsing, or full-page repaints) */}
      <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden="true">
        {/* Light theme radial gradient */}
        <div
          className="absolute inset-0 dark:opacity-0 opacity-100 transition-opacity duration-500"
          style={{
            backgroundImage: "radial-gradient(130% 85% at 50% 0%, #FFE0B3 0%, #FFF5EB 35%, #FFF8F0 75%, #FFFFFF 100%)",
          }}
        />
        {/* Dark theme radial gradient */}
        <div
          className="absolute inset-0 dark:opacity-100 opacity-0 transition-opacity duration-500"
          style={{
            backgroundImage: "radial-gradient(130% 85% at 50% 0%, #2a1b0a 0%, #171108 35%, #0f0a06 75%, #0a0a0a 100%)",
          }}
        />
      </div>

      {/* Floating Animated Paths */}
      <div className="fixed inset-0 z-0 pointer-events-none overflow-hidden">
        <FloatingPaths position={1} />
        <FloatingPaths position={-1} />
      </div>

      {/* Subtle overlay gradient */}
      <div
        className="absolute inset-0 bg-gradient-to-t from-white/20 via-transparent to-transparent dark:from-neutral-950/40 dark:via-transparent dark:to-transparent pointer-events-none z-0"
        aria-hidden="true"
      />

      {/* Page Content */}
      <div className="relative z-10 w-full max-w-full min-w-0">{children}</div>
    </div>
  );
}
